import { Component, OnInit } from '@angular/core';
import { AbandonedBuyflowDAO } from '../../../../core/services/dao/abandonedBuyflowDAO';
import { take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  sortByDate,
  sortCaseInsensitive,
} from '../../../../core/pure-functions/grids/grid-sorting-helper';
import { PostsDAO } from '../../../../core/services/dao/postsDAO';
import { EnvironmentalMediaService } from '../../../../core/services/environmental-media.service';
import { Post } from 'anchor-shared/lib/model/entity/posts';

@Component({
  selector: 'app-add-edit-posts',
  templateUrl: './add-edit-posts.component.html',
  styleUrls: ['./add-edit-posts.component.scss'],
})
export class AddEditPostsComponent implements OnInit {
  postId: number;
  loading = true;
  editingPost: Partial<Post> = null;
  previewContent: SafeHtml;
  textBoxChange = false;
  primaryActionText = 'Save Changes';
  loadingSection = '';
  suggestion = '';

  constructor(
    private readonly postsDAO: PostsDAO,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    private ems: EnvironmentalMediaService,
  ) {}

  ngOnInit(): void {
    this.postId = this.route.snapshot.params.id;
    console.log('have post id', this.postId);
    if (this.postId) {
      this.postsDAO
        .getPostById(this.postId)
        .pipe(take(1))
        .subscribe((post) => {
          this.editingPost = post;
          this.loading = false;
          this.editTextAreaChange(this.editingPost.content, true);
        });
    } else {
      this.primaryActionText = 'Save';
      this.loading = false;
      this.editingPost = {
        content: '',
        trailingUrl: '',
      };
    }
  }

  editTextAreaChange(change: any, preventInitialChange = false): void {
    if (!preventInitialChange) {
      this.textBoxChange = true;
    }
    this.previewContent = this.sanitizer.bypassSecurityTrustHtml(change);
  }

  trailingChange(): void {
    this.textBoxChange = true;
  }

  viewActualPost(): void {
    const url = this.ems.clientBase + this.editingPost.trailingUrl.substring(1);
    window.open(url, '_blank');
  }

  saveClick(): void {
    if (this.isEditMode()) {
      this.updateExisting();
    } else {
      this.saveNew();
    }
  }

  private saveNew(): void {
    this.postsDAO
      .createPost(this.editingPost)
      .pipe(take(1))
      .subscribe(
        (updatedPost) => {
          this.editingPost = updatedPost;
          this.openLocalSnack('Saved Successfully');
        },
        (err) => {
          console.log('error', err);
          this.openLocalSnack(
            'Error Saving.....Please try again or contact support.',
          );
        },
      );
  }

  generative(): void {
    this.loadingSection = 'descriptionLoading';
    this.postsDAO
      .getDescriptionSuggestion(this.editingPost.id)
      .pipe(take(1))
      .subscribe(
        (suggestion) => {
          this.loadingSection = '';
          this.suggestion = suggestion.description;
          console.log(suggestion);
          console.log(suggestion.description.length);
        },
        (err) => {
          this.loadingSection = '';
          console.log('error', err);
        },
      );
  }

  private updateExisting(): void {
    this.postsDAO
      .updateContentForPost(
        this.editingPost.id,
        this.editingPost.content,
        this.editingPost.trailingUrl,
        this.editingPost.metaTitle,
        this.editingPost.metaDescription,
        this.editingPost.metaImage,
      )
      .pipe(take(1))
      .subscribe(
        (updatedPost) => {
          this.openLocalSnack('Saved Successfully');
        },
        (err) => {
          console.log('error', err);
          this.openLocalSnack(
            'Error Saving.....Please try again or contact support.',
          );
        },
      );
  }

  private openLocalSnack(text: string): void {
    this.snackBar.open(text, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  private isEditMode(): boolean {
    return this.editingPost && this.editingPost.id > 0;
  }
}
